
/* OFFER EVENTS */
export const GET_EVENTS = "GET_EVENTS_"
export const SET_EVENTS = "SET_EVENTS"

/* LOADER */
export const SHOW_EVENTS_LOADER = "SHOW_EVENTS_LOADER"
export const HIDE_EVENTS_LOADER = "HIDE_EVENTS_LOADER"
